// wallet reducer types
export const CONNECT_WALLET = "CONNECT_WALLET";
export const DISCONNECT_WALLET = "DISCONNECT_WALLET";
export const GET_WEB3 = "GET_WEB3";
export const GET_ETHER_BALANCE = "GET_ETHER_BALANCE";
export const GET_ACCOUNTS = "GET_ACCOUNTS";

export const SET_ERRORS = "SET_ERRORS";
